var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.878 11.596l6.76-6.762-.942-.942-6.761 6.76v.944h.943zm.552 1.333H2.602V10.1l7.623-7.623a.667.667 0 01.943 0l1.886 1.886a.667.667 0 010 .943L5.43 12.929zm-2.828 1.333h12v1.334h-12v-1.334z",
    fill: "#888785"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuODc3NTYgMTEuNTk1NkwxMS42Mzg5IDQuODM0MjZMMTAuNjk2MiAzLjg5MTZMMy45MzQ5IDEwLjY1MjlWMTEuNTk1Nkg0Ljg3NzU2Wk01LjQzMDIzIDEyLjkyODlIMi42MDE1NlYxMC4xMDAzTDEwLjIyNDkgMi40NzY5M0MxMC4zNDk5IDIuMzUxOTUgMTAuNTE5NSAyLjI4MTc0IDEwLjY5NjIgMi4yODE3NEMxMC44NzMgMi4yODE3NCAxMS4wNDI1IDIuMzUxOTUgMTEuMTY3NiAyLjQ3NjkzTDEzLjA1MzYgNC4zNjI5M0MxMy4xNzg1IDQuNDg3OTUgMTMuMjQ4OCA0LjY1NzQ5IDEzLjI0ODggNC44MzQyNkMxMy4yNDg4IDUuMDExMDQgMTMuMTc4NSA1LjE4MDU4IDEzLjA1MzYgNS4zMDU2TDUuNDMwMjMgMTIuOTI4OVpNMi42MDE1NiAxNC4yNjIzSDE0LjYwMTZWMTUuNTk1NkgyLjYwMTU2VjE0LjI2MjNaIiBmaWxsPSIjODg4Nzg1Ii8+Cjwvc3ZnPgo=";
export { SvgEdit as ReactComponent };